import {
  DEFAULT_QUALITY_THRESHOLDS,
  LEAD_QUALITY_TIER,
  LEAD_QUALITY_VALUE_CENTS,
  MAX_PLAUSIBLE_QUANTITY,
  PRODUCT_QUALITY_THRESHOLDS,
  getLeadTypeValueMultiplier,
  type LeadQualityTier,
} from "../../constants/leadQuality";

export interface LeadQualityInput {
  productTypeSlug?: string;
  quantity?: number;
  leadType?: string;
}

export interface LeadQualityResult {
  tier: LeadQualityTier;
  appliedThresholds: {
    high: number;
    medium: number;
    low: number;
  };
  estimatedValueCents: number;
}

export function classifyLeadQuality(
  input: LeadQualityInput,
): LeadQualityResult {
  const thresholds =
    (input.productTypeSlug &&
      PRODUCT_QUALITY_THRESHOLDS[input.productTypeSlug]) ||
    DEFAULT_QUALITY_THRESHOLDS;

  const qty = input.quantity;
  const qtyIsUsable =
    typeof qty === "number" &&
    Number.isFinite(qty) &&
    qty > 0 &&
    qty <= MAX_PLAUSIBLE_QUANTITY;

  let tier: LeadQualityTier;
  if (!qtyIsUsable) {
    tier = LEAD_QUALITY_TIER.UNQUALIFIED;
  } else if (qty >= thresholds.high) {
    tier = LEAD_QUALITY_TIER.HIGH;
  } else if (qty >= thresholds.medium) {
    tier = LEAD_QUALITY_TIER.MEDIUM;
  } else if (qty >= thresholds.low) {
    tier = LEAD_QUALITY_TIER.LOW;
  } else {
    tier = LEAD_QUALITY_TIER.UNQUALIFIED;
  }

  const baseValueCents = LEAD_QUALITY_VALUE_CENTS[tier];
  const typeMultiplier = getLeadTypeValueMultiplier(
    input.leadType,
    input.productTypeSlug,
  );
  const estimatedValueCents = Math.round(baseValueCents * typeMultiplier);

  return {
    tier,
    appliedThresholds: thresholds,
    estimatedValueCents,
  };
}
